import React from 'react';
import { Link } from 'react-router-dom';
import { NavigationRouteType } from '../../../../Layouts/NavigationRoutes';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import styles from './LinkButton.module.scss';

export enum LinkButtonType {
    White = 'WHITE',
    Blue = 'BLUE',
}

export enum LinkButtonSize {
    Small = 'SMALL',
    Medium = 'MEDIUM',
    Large = 'LARGE',
}

interface ILinkButtonProps {
    title: string;
    type: LinkButtonType;
    size?: LinkButtonSize;
    icon?: any;
    navigateTo?: NavigationRouteType;
    onClick?: () => void;
    disabled?: boolean;
    testId?: string;
    track: TrackingEvent;
}

const LinkButton: React.FC<ILinkButtonProps> = (props: ILinkButtonProps) => {
    let buttonStyle = styles.button_blue;
    let linkStyle = styles.button_link_white;

    if (props.type === LinkButtonType.Blue) {
        buttonStyle = styles.button_blue;
        linkStyle = styles.button_link_white;
    } else if (props.type === LinkButtonType.White) {
        buttonStyle = styles.button_white;
        linkStyle = styles.button_link_blue;
    }

    let sizeClass = styles.button_size_medium;
    if (props.size === LinkButtonSize.Small) {
        sizeClass = styles.button_size_small;
    } else if (props.size === LinkButtonSize.Large) {
        sizeClass = styles.button_size_large;
    }

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        }

        if (props.navigateTo) {
            trackingService.track({
                ...props.track,
                eventValue: props.navigateTo,
            });
        } else {
            trackingService.track(props.track);
        }
    };

    return (
        <button type="button" data-testid={props.testId} disabled={props.disabled} className={`${buttonStyle} ${sizeClass}`} onClick={handleClick}>
            {props.icon && <span className={styles.button_icon}>{props.icon}</span>}
            {props.navigateTo ? (
                <Link className={linkStyle} to={props.navigateTo}>
                    {props.title}
                </Link>
            ) : (
                <div className={linkStyle}>{props.title}</div>
            )}
        </button>
    );
};

export default LinkButton;
